import { useSelector } from 'react-redux'
import { Row } from "react-bootstrap";
import { useState, useEffect } from 'react';
import { Table, Form, Empty } from 'antd';
import { getServices, getObjectiveCheck } from '../../libs/todoSlice'
import { getHistoryDetail } from '../../libs/historySlice';
import { useParams } from 'react-router-dom';

const HistoryDetailSuccess = () => {
  const params = useParams()

  const details = useSelector(getHistoryDetail)
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [objective, setObjective] = useState([]);
  const services = useSelector(getServices)
  const objectiveCheck = useSelector(getObjectiveCheck)
  useEffect(() => {
    setObjective(details.importHistories[details.importHistories.length - 1].objective)
    setData(details.importHistories[details.importHistories.length - 1].successDetail.map((items, index) => {
      return {
        loading: false,
        contract_no: items.request.contract_no ?? '-',
        title_th: items.request.title_th ?? '-',
        title_special_th: items.request.title_special_th ?? '-',
        employee_id: items.request.employee_id ?? '-',
        name_th: items.request.name_th ?? '-',
        surname_th: items.request.surname_th ?? '-',
        name_eng: items.request.name_eng ?? '-',
        surname_eng: items.request.surname_eng ?? '-',
        cid: items.request.cid ?? '-',
        address: items.request.address ?? '-',
        tel: items.request.tel ?? '-',
        mobile: items.request.mobile ?? '-',
        mobile_on: items.request.mobile_on ?? '-',
        email: items.request.email ?? '-',
        biz_email: items.request.biz_email ?? '-',
        position: items.request.position ?? '-',
        department: items.request.department ?? '-',
        sub_organization: items.request.sub_organization ?? '-',
        organization: items.request.organization ?? '-',
        tax_id: items.request.tax_id ?? '-',
        maintainer_name_1: items.request.maintainer_name_1 ?? '-',
        maintainer_surname_1: items.request.maintainer_surname_1 ?? '-',
        maintainer_name_2: items.request.maintainer_name_2 ?? '-',
        maintainer_surname_2: items.request.maintainer_surname_2 ?? '-',
        maintainer_name_3: items.request.maintainer_name_3 ?? '-',
        maintainer_surname_3: items.request.maintainer_surname_3 ?? '-',
        maintainer_name_4: items.request.maintainer_name_4 ?? '-',
        maintainer_surname_4: items.request.maintainer_surname_4 ?? '-',
        maintainer_email_1: items.request.maintainer_email_1 ?? '-',
        maintainer_email_2: items.request.maintainer_email_2 ?? '-',
        maintainer_email_3: items.request.maintainer_email_3 ?? '-',
        maintainer_email_4: items.request.maintainer_email_4 ?? '-',
        maintainer_tel_1: items.request.maintainer_tel_1 ?? '-',
        maintainer_tel_2: items.request.maintainer_tel_2 ?? '-',
        maintainer_tel_3: items.request.maintainer_tel_3 ?? '-',
        maintainer_tel_4: items.request.maintainer_tel_4 ?? '-',
        id_card_type: items.request.id_card_type,
        room_no: items.request.room_no,
        house_no: items.request.house_no,
        moo: items.request.moo,
        floor: items.request.floor,
        street: items.request.street,
        building_name: items.request.building_name,
        alley: items.request.alley,
        start_year: items.request.start_year,
        end_year: items.request.end_year,
        middle_name_th: items.request.middle_name_th,
        middle_name_eng: items.request.middle_name_eng,
        special_title_th: items.request.special_title_th,
        special_title_eng: items.request.special_title_eng,
        degree: items.request.degree,
        major: items.request.major,
        faculty: items.request.faculty,
        minor: items.request.minor,
        status: items.request.status,
        sub_district: items.request.sub_district,
        district: items.request.district,
        province: items.request.province,
        zipcode: items.request.zipcode,
        student_id: items.request.student_id,
        birth_date: items.request.birth_date,
        username: items.request.username,
        password: items.request.password,
      }
    }))
  }, [details])

  const customLocale = {
    emptyText: (<Empty
      description="ไม่มีข้อมูล"
    />)
  };
  const columns = [
    {
      title: 'ลำดับที่',
      width: 150,
      editable: true,
      show: true,
      render: (_, __, index) => index + 1
      // fixed: 'left',
    },
    {
      title: 'เลขที่สัญญา',
      dataIndex: 'contract_no',
      width: 150,
      editable: true,
      show: objective.includes('เลขที่หนังสือสัญญา')
      // fixed: 'left',
    },
    {
      title: 'รหัสพนักงาน',
      dataIndex: 'employee_id',
      width: 250,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (services.includes('one-id') || objectiveCheck.includes('ra')),
    },
    {
      title: 'คำนำหน้า',
      dataIndex: 'title_th',
      width: 150,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'คำนำหน้านาม',
      dataIndex: 'title_special_th',
      width: 200,
      show: objective.includes('Pre-register'),
      // hidden: !objective.includes('Pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // width: '10%',
      // editable: true,
    },
    {
      title: 'คำนำหน้าอื่นๆ (ภาษาไทย)',
      dataIndex: 'special_title_th',
      width: 180,
      editable: true,
      show: (objective.includes('edu-student-pre-register')) || (objective.includes('edu-teacher-pre-register')) || (objective.includes('edu-officer-pre-register')) || (services.includes('one-id') || objectiveCheck.includes('ra') || services.includes('one-id-pmuc')),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'คำนำหน้าอื่นๆ (ภาษาอังกฤษ)',
      dataIndex: 'special_title_eng',
      width: 180,
      editable: true,
      show: (objective.includes('edu-student-pre-register')) || (objective.includes('edu-teacher-pre-register')) || (objective.includes('edu-officer-pre-register')) || (services.includes('one-id') || objectiveCheck.includes('ra') || services.includes('one-id-pmuc')),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'เลขประจำตัวบุคลากรทางการแพทย์',
      dataIndex: 'employee_id',
      width: 180,
      editable: true,
      show: objective.includes('Pre-register'),
      //   hidden: !objective.includes('Pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ชื่อ (ภาษาไทย)',
      dataIndex: 'name_th',
      width: 150,
      editable: true,
      show: true,
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ชื่อกลาง (ภาษาไทย)',
      dataIndex: 'middle_name_th',
      width: 150,
      show: objective.includes('edu-student-pre-register') || objective.includes('edu-officer-pre-register'),
      // width: '10%',
      editable: true,
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: <>
        นามสกุล <br />(ภาษาไทย)
      </>,
      dataIndex: 'surname_th',
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ชื่อ (ภาษาอังกฤษ)',
      dataIndex: 'name_eng',
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ชื่อกลาง (ภาษาอังกฤษ)',
      dataIndex: 'middle_name_eng',
      width: 150,
      show: objective.includes('edu-student-pre-register') || objective.includes('edu-officer-pre-register'),
      // width: '10%',
      editable: true,
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: <>
        นามสกุล <br />(ภาษาอังกฤษ)
      </>,
      dataIndex: 'surname_eng',
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ฉายา (ภาษาไทย)',
      dataIndex: 'nickname_th',
      width: 150,
      editable: true,
      show: objective.includes('edu-teacher-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('surname_eng'),
    },
    {
      title: 'ฉายา (อังกฤษ)',
      dataIndex: 'nickname_eng',
      width: 180,
      editable: true,
      show: (objective.includes('edu-teacher-pre-register')),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'ประเภทบัตร',
      dataIndex: 'id_card_type',
      width: 180,
      show: (objective.includes('edu-student-pre-register')) || (objective.includes('edu-teacher-pre-register')) || (objective.includes('edu-officer-pre-register')),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'เลขประจำตัวประชาชน',
      dataIndex: 'cid',
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ระดับการศึกษา',
      dataIndex: 'degree',
      width: 180,
      editable: true,
      show: objective.includes('edu-student-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'คณะ',
      dataIndex: 'faculty',
      width: 180,
      editable: true,
      show: objective.includes('edu-student-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'Major (สาขา/ภาควิชา)',
      dataIndex: 'major',
      width: 180,
      editable: true,
      show: objective.includes('edu-student-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'Minor (ถ้ามี)',
      dataIndex: 'minor',
      width: 180,
      editable: true,
      show: objective.includes('edu-student-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'สถานะการศึกษา',
      dataIndex: 'status',
      width: 180,
      editable: true,
      show: objective.includes('edu-student-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'ที่อยู่',
      dataIndex: 'address',
      width: 400,
      editable: true,
      show: objective.includes('import-excel-rama'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ที่อยู่',
      dataIndex: 'address',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('edu-teacher-pre-register')),
      // ...getColumnSearchProps('address'),
    },
    {
      title: 'บ้านเลขที่',
      dataIndex: 'house_no',
      width: 150,
      editable: true,
      // show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'ห้องที่',
      dataIndex: 'room_no',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // show: (objective.includes('edu-student-pre-register')),
      // ...getColumnSearchProps('address'),
    },
    {
      title: 'หมู่ที่',
      dataIndex: 'moo',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // show: (objective.includes('edu-student-pre-register')),
      // ...getColumnSearchProps('address'),
    },
    {
      title: 'ชั้นที่',
      dataIndex: 'floor',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // show: (objective.includes('edu-student-pre-register')),
      // ...getColumnSearchProps('address'),
    },
    {
      title: 'ถนน',
      dataIndex: 'street',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // show: (objective.includes('edu-student-pre-register')),
      // ...getColumnSearchProps('address'),
    },
    {
      title: 'อาคาร',
      dataIndex: 'building_name',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // show: (objective.includes('edu-student-pre-register')),
      // ...getColumnSearchProps('address'),
    },
    {
      title: 'หมู่บ้าน',
      dataIndex: 'alley',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // show: (objective.includes('edu-student-pre-register')),
      // ...getColumnSearchProps('address'),
    },
    {
      title: 'ตำบล',
      dataIndex: 'sub_district',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // show: (objective.includes('edu-teacher-pre-register')) || (objective.includes('edu-student-pre-register')),
      // ...getColumnSearchProps('address'),
    },
    {
      title: 'อำเภอ',
      dataIndex: 'district',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // show: (objective.includes('edu-teacher-pre-register')) || (objective.includes('edu-student-pre-register')),
      // ...getColumnSearchProps('address'),
    },
    {
      title: 'จังหวัด',
      dataIndex: 'province',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // show: (objective.includes('edu-teacher-pre-register')) || (objective.includes('edu-student-pre-register')),
      // ...getColumnSearchProps('address'),
    },
    {
      title: 'รหัสไปรษณีย์',
      dataIndex: 'zipcode',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // show: (objective.includes('edu-teacher-pre-register')) || (objective.includes('edu-student-pre-register')),
      // ...getColumnSearchProps('address'),
    },
    {
      title: 'วันที่เริ่มการศึกษา',
      dataIndex: 'start_year',
      width: 150,
      editable: true,
      // show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'วันที่จบการศึกษา',
      dataIndex: 'end_year',
      width: 150,
      editable: true,
      // show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'โทรศัพท์',
      dataIndex: 'tel',
      width: 150,
      editable: true,
      show: false,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'โทรศัพท์มือถือ',
      dataIndex: 'mobile',
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'อีเมล',
      dataIndex: 'email',
      width: 250,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'อีเมลองค์กร',
      dataIndex: 'biz_email',
      width: 250,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (services.includes('one-id') || objectiveCheck.includes('ra')),
    },
    {
      title: 'username',
      dataIndex: 'username',
      width: 180,
      editable: true,
      show: (services.includes('one-id') || objectiveCheck.includes('ra')),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'รหัสนักศึกษา',
      dataIndex: 'student_id',
      width: 180,
      editable: true,
      show: objective.includes('edu-student-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'วันเกิด (ปปปป-ดด-วว)',
      dataIndex: 'birth_date',
      width: 180,
      editable: true,
      show: (objective.includes('edu-teacher-pre-register')) || objective.includes('Pre-register') || (objective.includes('edu-student-pre-register')) || (objective.includes('edu-officer-pre-register')),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
      render: (_) => {
        return <>{_}</>
      }
    },
    {
      title: 'username',
      dataIndex: 'username',
      width: 180,
      editable: true,
      show: (objective.includes('edu-teacher-pre-register')),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'password',
      dataIndex: 'password',
      width: 180,
      editable: true,
      show: (objective.includes('edu-teacher-pre-register')),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],

      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'ตำแหน่งของเจ้าของใบรับรอง',
      dataIndex: 'position',
      width: 150,
      editable: true,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ตำแหน่ง',
      dataIndex: 'position',
      width: 150,
      editable: true,
      show: objective.includes('Pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ชื่อของหน่วยงานย่อยในองค์กรที่เจ้าของใบรับรองสังกัด',
      dataIndex: 'sub_organization',
      width: 250,
      editable: true,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ชื่อองค์กรที่เจ้าของใบรับรองสังกัด',
      dataIndex: 'organization',
      width: 350,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'โรงพยาบาลที่สังกัด',
      dataIndex: 'organization',
      width: 350,
      show: objective.includes('Pre-register') || objective.includes('import-excel-rama'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'เลขประจำตัวผู้เสียภาษีอากรของนิติบุคคล',
      dataIndex: 'tax_id',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ชื่อคนที่ 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_name_1',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'นามสกุลคนที่ 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_surname_1',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ชื่อคนที่ 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_name_2',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'นามสกุลคนที่ 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_surname_2',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ชื่อคนที่ 3 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_name_3',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'นามสกุลคนที่ 3 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_surname_3',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ชื่อคนที่ 4 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_name_4',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'นามสกุลคนที่ 4 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_surname_4',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    

    {
      title: 'อีเมล 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_email_1',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'อีเมล 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_email_2',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'อีเมล 3 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_email_3',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'อีเมล 4 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_email_4',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'โทรศัพท์มือถือ 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_tel_1',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'โทรศัพท์มือถือ 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_tel_2',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'โทรศัพท์มือถือ 3 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_tel_3',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'โทรศัพท์มือถือ 4 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_tel_4',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'โทรศัพท์มือถือ',
      dataIndex: 'mobile',
      width: 150,
      editable: true,
      show: services.includes('one-id-ra'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'แผนก',
      dataIndex: 'department',
      width: 120,
      editable: true,
      show: services.includes('one-id-ra') || (services.includes('one-id') || objectiveCheck.includes('ra')),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ตำแหน่ง',
      dataIndex: 'position',
      width: 120,
      editable: true,
      show: services.includes('one-id-ra') || (services.includes('one-id') || objectiveCheck.includes('ra')),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
  ].filter(head => head.show);
  return (
    <Row>
      {/* ui table */}
      <Form form={form} component={false}>
        <Table
          locale={customLocale}
          bordered
          dataSource={data}
          columns={columns}
          rowClassName="editable-row"
          pagination={{ pageSize: 10 }}
          scroll={{
            x: 1400,
            y: 400,
          }}

        />
      </Form>
      {/* end ui table */}
    </Row>
  )
}
export default HistoryDetailSuccess